import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, MessageSquare, ChevronDown } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'María Laura G.',
  text: 'Este kit cambió mi forma de ver mis heridas. Por fin pude soltar lo que me pesaba hace años y volver a sentirme liviana.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 2,
  name: 'Sofía Rodríguez',
  text: 'Los rituales son mágicos, me siento mucho más conectada conmigo misma. La sección de aromaterapia es mi favorita.',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 3,
  name: 'Carlos Martínez',
  text: 'Nunca pensé que un libro digital pudiera acompañarme tanto. Las herramientas son prácticas y fáciles de aplicar día a día.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 4,
  name: 'Ana Paula S.',
  text: 'Un antes y un después en mi paz mental. Siento que volví a priorizarme después de mucho tiempo de vivir en automático.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 5,
  name: 'Lucía García',
  text: 'Recomiendo el pack premium, el recetario ancestral es una joya que uso todas las semanas para mi bienestar.',
  image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 6,
  name: 'Martina Suárez',
  text: 'Las meditaciones guiadas me ayudan a dormir mejor y a gestionar mi ansiedad de forma natural. Gracias por esto.',
  image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 7,
  name: 'Javier Domínguez',
  text: 'Excelente material. Me ayudó a entender mis emociones y a no juzgarme tanto por lo que siento.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 8,
  name: 'Elena Vázquez',
  text: 'Un regalo para el alma. El diseño es hermoso y la calidez de las palabras te hace sentir muy acompañada.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 9,
  name: 'Patricia B.',
  text: 'Lo leo en mi tablet todas las mañanas, es mi momento sagrado. Me ha dado mucha claridad mental.',
  image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0ad2f01?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 10,
  name: 'Roberto F.',
  text: 'La mejor inversión que hice para mi bienestar este año. Contenido de muchísima calidad y valor.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 11,
  name: 'Gabriela T.',
  text: 'Siento que recuperé mi energía. Los baños y limpiezas energéticas me renovaron por completo.',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 12,
  name: 'Mónica H.',
  text: 'Muy completo y profundo. Se nota que hay mucho amor y dedicación puesto en cada página.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 13,
  name: 'Sandra P.',
  text: 'Me ayudó a poner límites y a entender que mi bienestar es lo primero. Una guía fundamental.',
  image: 'https://images.unsplash.com/photo-1548142813-c348350df52b?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 14,
  name: 'Diego A.',
  text: 'Las tablas y checklists me ayudaron a organizar mi proceso de sanación. Muy recomendable.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  id: 15,
  name: 'Valeria M.',
  text: 'Gracias por crear este espacio para volver a una misma. Me siento en paz por primera vez en mucho tiempo.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&q=80&w=200',
  rating: 5
}];
export function TestimonialsSection() {
  const [visibleCount, setVisibleCount] = useState(4);
  const showMore = () => setVisibleCount(prev => Math.min(prev + 4, testimonials.length));
  return <section id="testimonios" className="py-24 px-4 relative overflow-hidden bg-[#2C2541] pt-[20px] pb-[20px]" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-sm font-medium mb-6" data-id="element-178">
            <MessageSquare className="w-4 h-4" data-id="element-179" />
            <span data-id="element-180">Historias de transformación</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#D9B15F] mb-6" data-id="element-181">
            Lo que dicen quienes ya empezaron
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-182">
          <AnimatePresence mode="popLayout" data-id="element-183">
            {testimonials.slice(0, visibleCount).map((item, index) => <motion.div key={item.id} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4,
            delay: index % 4 * 0.1
          }} className="bg-[#3A3158]/40 backdrop-blur-sm border border-[#D9B15F]/10 p-6 rounded-3xl flex flex-col md:flex-row gap-6 items-center md:items-start group hover:border-[#D9B15F]/30 transition-all" data-id="element-184">
                <div className="shrink-0" data-id="element-185">
                  <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-[#D9B15F]/20 shadow-xl group-hover:border-[#D9B15F]/50 transition-colors" data-id="element-186">
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-187" />
                  </div>
                </div>
                <div className="flex-grow text-center md:text-left" data-id="element-188">
                  <div className="flex justify-center md:justify-start gap-1 mb-3" data-id="element-189">
                    {[...Array(item.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D9B15F] text-[#D9B15F]" data-id="element-190" />)}
                  </div>
                  <p className="text-[#F8F5F2] italic mb-4 leading-relaxed" data-id="element-191">
                    "{item.text}"
                  </p>
                  <h4 className="text-[#D9B15F] font-bold uppercase tracking-widest text-xs" data-id="element-192">
                    {item.name}
                  </h4>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {visibleCount < testimonials.length && <div className="text-center" data-id="element-193">
            <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={showMore} className="inline-flex items-center gap-2 bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] px-8 py-4 rounded-full font-bold uppercase tracking-widest text-sm hover:bg-[#D9B15F]/20 transition-all" data-id="element-194">
              Ver más testimonios
              <ChevronDown className="w-4 h-4" data-id="element-195" />
            </motion.button>
          </div>}
      </div>
    </section>;
}